type AgendaOnlineMeetingProps = {
    joinUrl: string;
    conferenceId: string;
    tollNumber: string;
};

export default class AgendaOnlineMeeting {
    joinUrl: string;

    conferenceId: string;

    tollNumber: string;

    constructor({
        joinUrl,
        conferenceId,
        tollNumber,
    }: AgendaOnlineMeetingProps) {
        this.joinUrl = joinUrl;
        this.conferenceId = conferenceId;
        this.tollNumber = tollNumber;
    }
}
